import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ICON_BRIEFCASE, ICON_EDIT } from '../../../../extras/icons';
import VictimEditForm from '../../treatment/forms/VictimEditForm';
import { APROBADA, AGENDADA } from '../../../../../data/audienceStates';
import VictimDefenseEditForm from '../../treatment/forms/VictimDefenseEditForm';
//Authorities
import Authorities from '../../../../../services/AuthoritiesService';
import { SOLICITUDES_MODIFICAR } from '../../../../../data/objects';
import { useSelector } from 'react-redux';
//Función principal
const VictimInfo = props => {
    //Tomo los props
    const { index, victim, audience } = props;
    //Traigo el store
    const authUser = useSelector(state => state.auth.user);
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [showEdit, setShowEdit] = useState(false);
    const [showEditDefense, setShowEditDefense] = useState(false);
    //Manejo la apertura
    const handleOpen = () => {
        setShowEdit(true);
    }
    const handleOpenDefense = () => {
        setShowEditDefense(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShowEdit(false);
    }
    const handleCloseDefense = () => {
        setShowEditDefense(false);
    }
    //Analizo si puede editar
    let canEdit = false;
    if(audience && audience.estado && audience.estado.id >= APROBADA && audience.estado.id <= AGENDADA){
        //Verifico permisos
        if(authorities && Authorities.hasPermission(authorities, SOLICITUDES_MODIFICAR)){
            //Puede editar
            canEdit = true;
        }
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card mb-2 border-secondary">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-dark">VICTIMA #{index + 1}</h6>
                    {
                        canEdit ? (
                            <div className="dropdown no-arrow">
                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpenDefense}>
                                    <ICON_BRIEFCASE />
                                </Button>

                                <VictimDefenseEditForm
                                    show={showEditDefense}
                                    handleClose={handleCloseDefense}
                                    audience={audience}
                                    victim={victim}
                                />

                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpen}>
                                    <ICON_EDIT />
                                </Button>

                                <VictimEditForm
                                    show={showEdit}
                                    handleClose={handleClose}
                                    audience={audience}
                                    victim={victim}
                                />
                            </div>
                        ) : null
                    }
                </div>
                <div className="card-body">
                    <div className="h6 mb-0 font-weight-bold text-gray-800">
                        <div className="row">
                            <div className="col-md-6 mb-1">
                                <small>APELLIDO Y NOMBRE:</small>
                                <br/>
                                { `${victim.persona.apellido}, ${victim.persona.nombre}` }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TIPO Y NÚMERO DOC.:</small>
                                <br/>
                                {
                                    victim.persona && victim.persona.identificacion ? (
                                        `${victim.persona.tipoDocumento}: ${victim.persona.identificacion}`
                                    ) : null
                                }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>ES MENOR?:</small>
                                <br/>
                                { victim.menor === 1 ? 'SI' : 'NO' }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DOMICILIO:</small>
                                <br/>
                                { victim.domicilio }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TELÉFONO:</small>
                                <br/>
                                { victim.telefono ? victim.telefono : 'N/D' }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>EMAIL:</small>
                                <br/>
                                { victim.email ? victim.email : 'N/D' }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>ES QUERELLANTE?:</small>
                                <br/>
                                { victim.querellante === 1 ? 'SI' : 'NO' }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DEFENSA PÚBLICA:</small>
                                <br/>
                                {
                                    victim.defensoria ? (
                                        `${victim.defensoria.descripcion}`
                                    ) : null
                                }
                            </div>
                            {
                                victim.victimaParticularesList && victim.victimaParticularesList.length ? (
                                    <div className="col-12 mb-1">
                                        <table className="table table-bordered table-sm">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th colSpan="3" className="align-middle text-center">
                                                        DEFENSORES PARTICULARES
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Apellido y Nombre</th>
                                                    <th className="text-center">Email</th>
                                                    <th className="text-center">Teléfono</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    victim.victimaParticularesList.map(particular => (
                                                        <tr key={`vip${particular.id}`}>
                                                            <td>{ `${particular.persona.apellido}, ${particular.persona.nombre}` }</td>
                                                            <td className="text-center">{ particular.email }</td>
                                                            <td className="text-center">{ particular.telefono }</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VictimInfo;